import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/services', label: 'Services' },
    { to: '/hotels', label: 'Hotels' },
    { to: '/offices', label: 'Offices' },
    { to: '/domestic', label: 'Home Cleaning' },
    { to: '/why-choose-us', label: 'Why Choose Us' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <nav
      ref={navRef}
      className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}
    >
      <div className="navbar__inner container">
        <Link to="/" className="navbar__brand">
          <img
            src="/images/commercial_carpet_cleaning_oxon_logo.png"
            alt="Commercial Carpet Cleaning Oxon"
            className="navbar__logo"
          />
          <span className="navbar__name">
            Commercial Carpet<br className="navbar__name-break" /> Cleaning Oxon
          </span>
        </Link>

        <ul className="navbar__links">
          {navLinks.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className={`navbar__link${location.pathname === to ? ' navbar__link--active' : ''}`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>

        <a href="tel:+447887394404" className="navbar__phone btn btn--primary">
          <span className="navbar__phone-icon">&#9742;</span>
          07887 394404
        </a>

        <button
          className={`navbar__toggle${menuOpen ? ' navbar__toggle--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div className={`navbar__mobile${menuOpen ? ' navbar__mobile--open' : ''}`}>
        <ul>
          {navLinks.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className={`navbar__mobile-link${location.pathname === to ? ' navbar__mobile-link--active' : ''}`}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
        <a href="tel:+447887394404" className="navbar__mobile-phone btn btn--primary">
          Call Us: 07887 394404
        </a>
      </div>
    </nav>
  );
}

export default Navbar;
